// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-ucCIHT {
  line-height: 1;
}

.\\------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-ucCIHT .semi-button-with-icon-only.semi-button-borderless:not(.semi-button-disabled):hover {
  background: var(--light-usage-fill-color-fill-1, rgba(46, 46, 56, .08));
}

.\\------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-ucCIHT .semi-button-with-icon-only.semi-button-borderless:not(.semi-button-disabled):active {
  background: var(--light-usage-fill-color-fill-2, rgba(46, 46, 56, .12));
}

.\\------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-small-Z2ZC4N .semi-button-with-icon-only {
  border-radius: 4px;
  height: 18px;
  padding: 2px !important;
}

.\\------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-small-Z2ZC4N svg {
  width: 14px;
  height: 14px;
}

.\\------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-default-GHMTzj .semi-button-with-icon-only {
  border-radius: 4px;
  height: 24px;
  padding: 4px !important;
}

.\\------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-default-GHMTzj svg {
  width: 16px;
  height: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-large-KTU72g .semi-button-with-icon-only {
  border-radius: 6px;
  height: 32px;
  padding: 4px !important;
}

.\\------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-large-KTU72g svg {
  width: 24px;
  height: 24px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-button": `------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-ucCIHT`,
	"iconButton": `------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-ucCIHT`,
	"icon-button-small": `------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-small-Z2ZC4N`,
	"iconButtonSmall": `------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-small-Z2ZC4N`,
	"icon-button-default": `------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-default-GHMTzj`,
	"iconButtonDefault": `------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-default-GHMTzj`,
	"icon-button-large": `------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-large-KTU72g`,
	"iconButtonLarge": `------packages-components-bot-semi-src-components-ui-icon-button-index-module__icon-button-large-KTU72g`
};
export default ___CSS_LOADER_EXPORT___;
